import { RootState } from "store/index";

const isSaving = (state: RootState): boolean =>
  state.menuBatchOperation.isSaving;

const error = (state: RootState): string | null | undefined =>
  state.menuBatchOperation.error;

export default {
  isSaving,
  error,
};
